import correct from '@/assets/img/documents/cost-estimate-before.jpg';
import wrong from '@/assets/img/documents/cost-estimate-before-wrong.jpg';
import Card from '@/components/Card';
import ChatMessage from '@/components/ChatMessage';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const COST_ESTIMATE_BEFORE_ACCIDENT_NAME =
  'cost_estimate_before_accident';

const CostEstimateBeforeAccident = ({
  required = false,
}: {
  required?: boolean;
}) => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać arkusz wyceny sprzed szkody?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane pojazdu są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony dokumentu.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Arkusz wyceny pojazdu przed szkodą ')}
          instructionProps={instructionProps}
          inputFieldName={COST_ESTIMATE_BEFORE_ACCIDENT_NAME}
          required={required}
          attachmentTypeId={ATTACHMENT_TYPES.ARKUSZ_WYCENY_POJAZDU_PRZED_SZKODA}
        />
      </Card>
      {!required && (
        <ChatMessage
          variant="secondary"
          className="mt-3 lg:mt-5"
          description={i18n.t(
            'Jeśli posiadasz arkusz wyceny pojazdu przed szkodą, to warto go załączyć już teraz. Będzie stanowił dodatkowe źródło informacji dla rzeczoznawcy.'
          )}
        />
      )}
    </div>
  );
};

export default CostEstimateBeforeAccident;
